'use strict';

var formValidation = require('../components/formValidation');
var accountRegistrationUtils = require('./accountRegistrationUtils');

var { helpers } = accountRegistrationUtils;
module.exports = {

    init: function () {
        helpers.handleCountrySelection();
        helpers.handlePhoneCountrySelection();
    },
    register: function () {
        $('body').on('blur', '#registration-form-password-confirm', function () {
            // eslint-disable-next-line no-underscore-dangle
            var _this = $(this);
            var pwd = $('#registration-form-password').val();
            var confirmpwd = _this.val();
            if (pwd === confirmpwd) {
                _this.removeClass('is-invalid');
                _this.closest('.form-group').find('.invalid-feedback').html('');
            } else {
                _this.addClass('is-invalid');
                _this.closest('.form-group').find('.invalid-feedback').show();
                _this.closest('.form-group').find('.invalid-feedback').html(_this.data('confirm-error'));
            }
        });
        helpers.submitValidation();
        helpers.setRadioOnChange();
    },
    login: function () {
        $('form#registered-customer').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form#registered-customer').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    } else {
                        $('form.login').trigger('login:success', data);
                        // eslint-disable-next-line no-restricted-globals
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    }
};
